import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Center } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers';
import { TForgotPasswordProps, useForgotPassword } from '@olo-web/domain/customer';
import { HookFormInput } from '@olo-web/components/molecules/HookFormInput/HookFormInput.ui';
import { validationSchema } from './utils/validationSchema';
import { useModalState } from '@olo-web/client-state';

export function ForgotPasswordForm({
  onSettled,
}: {
  onSettled?: (data: any, error: any, variables: TForgotPasswordProps | string) => void;
}): JSX.Element {
  const { register, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  const { isLoading, mutate } = useForgotPassword({ onSettled });

  const { modalContext } = useModalState();

  const onSubmit = (data) => {
    mutate(data.email);
  };

  return (
    <form style={{ width: '100%' }} onSubmit={handleSubmit(onSubmit)}>
      <HookFormInput
        isRequired
        isUsingYup
        label="Email"
        type="email"
        autoComplete="email"
        errors={errors}
        name="email"
        nameReq="email required"
        defaultValue={modalContext?.email || ''}
        placeholder="yummy@food.com"
        ref={register}
      />
      <Center mt={6} flexDir="column">
        <Button
          w="100%"
          size="lg"
          colorScheme="primary"
          loadingText="Sending link..."
          isLoading={isLoading}
          type="submit"
          mb={2}
        >
          Send password reset link
        </Button>
      </Center>
    </form>
  );
}
